import { api, getToken } from "./api";
import { renderSubscription, tonLink } from "./subscription";
import { t } from "./i18n";
import { renderMcpAccess } from "./mcp_access";

export async function renderBilling(el: HTMLElement): Promise<void> {
  if (!getToken()) {
    el.innerHTML = `<div class="card empty">${t("billing.first_login")} <a href="#/login">${t("nav.login")}</a></div>`;
    return;
  }
  el.innerHTML = `<div class="card"><p class="hint">…</p></div>`;
  let c: any;
  let b: any;
  let p: any;
  try {
    [c, b, p] = await Promise.all([api.credits(), api.buyInfo(), api.payments()]);
  } catch (error: any) {
    if (error.status === 401 || !getToken()) {
      el.innerHTML = `<div class="card empty">${t("billing.first_login")} <a href="#/login">${t("nav.login")}</a></div>`;
    } else {
      el.innerHTML = `<div class="card empty">${t("login.error", { msg: error.message })}</div>`;
    }
    return;
  }
  el.innerHTML = `
    <h1>${t("billing.title")}</h1>
    <div class="card balance-grid">
      <div>
        <h3>${t("billing.balance")}</h3>
        <div class="balance-num">${c.credits.toLocaleString()}</div>
        <div class="balance-meta">${t("billing.balance_meta", { usd: c.usd_equiv, rate: c.rate })}</div>
      </div>
      <a href="#/chat" class="btn ghost">${t("billing.open_chat")}</a>
    </div>
    <div class="card" id="sub-section" style="margin-top:16px"></div>
    <div class="card" id="mcp-section" style="margin-top:16px"></div>
    <div class="card" style="margin-top:16px">
      <h2>${t("billing.topup_title")}</h2>
      <dl class="kv">
        <dt>${t("billing.address")}</dt><dd><code>${b.ton_wallet}</code></dd>
        <dt>${t("billing.memo")}</dt><dd><code>${b.memo}</code></dd>
      </dl>
      <p class="hint" style="margin-top:14px">${b.instructions}</p>
      <div class="pack-grid">
        ${b.packages.map((pk: any) => `
          <a class="pack" href="${tonLink(b.ton_wallet, pk.ton, b.memo)}">
            <div class="pack-amt">${pk.ton} TON</div>
            <div class="pack-cr">${pk.credits.toLocaleString()} ${t("billing.col_credits")}</div>
            <div class="pack-cta">${t("billing.pack_cta")}</div>
          </a>`).join("")}
      </div>
    </div>
    <div class="card" style="margin-top:16px">
      <h2>${t("billing.history_title")}</h2>
      ${p.payments.length ? `
        <div class="table-wrap"><table class="ledger">
          <thead><tr><th>${t("billing.col_when")}</th><th>${t("billing.col_ton")}</th><th>${t("billing.col_credits")}</th><th>${t("billing.col_tx")}</th></tr></thead>
          <tbody>
            ${p.payments.map((x: any) => `
              <tr>
                <td>${(x.at || "").slice(0, 19).replace("T", " ")}</td>
                <td>${x.amount_ton}</td>
                <td class="pos">+${x.credits}</td>
                <td><code>${x.tx_hash.slice(0, 12)}…</code></td>
              </tr>`).join("")}
          </tbody>
        </table></div>
      ` : `<p class="hint">${t("billing.history_empty")}</p>`}
    </div>
    <div class="card" style="margin-top:16px">
      <h2>${t("billing.movement_title")}</h2>
      ${c.history.length ? `
        <table class="ledger">
          <thead><tr><th>${t("billing.col_when")}</th><th>${t("billing.col_change")}</th><th>${t("billing.col_reason")}</th></tr></thead>
          <tbody>
            ${c.history.slice(0, 30).map((h: any) => `
              <tr>
                <td>${(h.at || "").slice(0, 19).replace("T", " ")}</td>
                <td class="${h.delta > 0 ? 'pos' : 'neg'}">${h.delta > 0 ? '+' : ''}${h.delta}</td>
                <td>${h.reason}</td>
              </tr>`).join("")}
          </tbody>
        </table></div>
      ` : `<p class="hint">${t("billing.movement_empty")}</p>`}
    </div>
  `;

  const subEl = el.querySelector<HTMLDivElement>("#sub-section");
  if (subEl) renderSubscription(subEl);
  const mcpEl = el.querySelector<HTMLDivElement>("#mcp-section");
  if (mcpEl) renderMcpAccess(mcpEl);
}
